'use client'

export async function bootstrapAccount() {
  const response = await fetch('/api/auth/bootstrap', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(data.error || 'Failed to set up your account')
  }

  return data as { org_id: string; already_existed?: boolean }
}
